export const getSituacaoId = (status: string): string => {
  const situacaoMap: { [key: string]: string } = {
    ativado: "1",
    cancelado: "2",
    trancado: "3",
    travado: "4",
    concluído: "5",
  };

  return situacaoMap[status] || "1"; // Default para "Ativo" se não encontrar
};

export const getSituacaoLabel = (id: string | number): string => {
  const idStr = String(id ?? "").trim();

  const map: Record<string, string> = {
    "1": "ativado",
    "2": "cancelado",
    "3": "trancado",
    "4": "travado",
    "5": "concluído",
  };

  return map[idStr] || "ativado";
};
